var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTag',{attrs:{"tone":_vm.tone,"preset":"primary"}},[_vm._v(" "+_vm._s(_vm.$t(`search-filters.status.${_vm.status}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }